const systemConfig = {
    requestIp: 'http://192.168.0.43:8080',
    imageUrl:'dev-platform-dev/dtwiki'
}
export default systemConfig